import { type KeysToCamelCase } from '@pkg/types';

import config from '@app/config';
import { type NFTContent } from '@app/store/types/yat-page-actions';

interface MasherTransformProps extends Partial<KeysToCamelCase<NFTContent>> {
    url?: string;
    width?: number;
    // Early return the provided `url` if it is already mashed
    // and you do not care about differences in parameters (width).
    skipReMash?: boolean;
}

const urlSegments = {
    mashUrl: config.mediaMasherUrl,
    subDirectory: '/mash/c_fit',
    widthPrefix: ',w_',
    resize(width?: number) {
        return width ? this.widthPrefix + width : '';
    },
    originalUrl(url: string) {
        return `/${url}`;
    },
};

const postMashedUrlRegex = new RegExp(`^${urlSegments.mashUrl}${urlSegments.subDirectory}[^/]*/`);

export function getMashedUrl({ url, width, skipReMash = false }: MasherTransformProps) {
    if (!url || Boolean(url.includes(config.mediaMasherUrl) && skipReMash)) return url;

    if (url.indexOf('data:image/') === 0) {
        // Render the raw image directly.
        return url;
    }

    if (url.indexOf('data:application/json') === 0) {
        try {
            const base64 = url.split(',').pop() || '';
            const json = JSON.parse(Buffer.from(base64, 'base64').toString());

            if (json.image_data && json.image_data.indexOf('<svg') !== -1) {
                return `data:image/svg+xml;base64,${Buffer.from(json.image_data, 'utf-8').toString('base64')}`;
            }
        } catch (_error) {
            // Continue though it will probably error out.
        }
    }

    const cleanUrl = postMashedUrlRegex.test(url) ? url.replace(postMashedUrlRegex, '') : url;

    return (
        urlSegments.mashUrl + urlSegments.subDirectory + urlSegments.resize(width) + urlSegments.originalUrl(cleanUrl)
    );
}
